import { render, staticRenderFns } from "./DefInputZip.vue?vue&type=template&id=4f891b3c&"
import script from "./DefInputZip.vue?vue&type=script&lang=js&"
export * from "./DefInputZip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports